import { getRobePaths, getRobeProps } from "xcore";

import ProductDetail, { getXcoreProps } from "../[id]";

export const getStaticProps = getRobeProps(getXcoreProps);

export const getStaticPaths = getRobePaths("accessory");

export default ProductDetail;
